// extracted by mini-css-extract-plugin
export var blue = "richtext-module--blue--f667e";
export var green = "richtext-module--green--91c16";
export var red = "richtext-module--red--199bc";